import { useAuthStore } from '@lib/store/auth.store';
import { UserRole } from '@lib/types';

export function EmpresaSelector() {
  const { empresas, empresaActivaId, setEmpresaActiva, user } = useAuthStore();

  if (!user) return null;
  if (empresas.length === 0) return null;
  // Un usuario de organización con una sola no tiene nada para elegir. Para los
  // demás roles el selector se muestra aunque haya una sola: el store la deja
  // activa por defecto (así funcionan las acciones que exigen organización,
  // como cargar modificaciones o ver Documentación), y este selector es la
  // única forma de volver a la vista global.
  if (user.rol === UserRole.USUARIO_EMPRESA && empresas.length <= 1) return null;

  return (
    <div className="empresaSelector">
      <label htmlFor="empresa-activa">Organización activa</label>
      <select
        id="empresa-activa"
        value={empresaActivaId ?? ''}
        onChange={(e) => setEmpresaActiva(e.target.value || null)}
      >
        {user.rol !== UserRole.USUARIO_EMPRESA && (
          <option value="">— Todas (vista global) —</option>
        )}
        {empresas.map((e) => (
          <option key={e.id} value={e.id}>
            {e.nombreComercial} · CUIT {e.cuit}
          </option>
        ))}
      </select>
    </div>
  );
}
